module.exports = __webpack_public_path__ + "img/arrow-left-3.0ceb5fd5.svg";